import { render, staticRenderFns } from "./userDetail.vue?vue&type=template&id=0d92df07"
import script from "./userDetail.vue?vue&type=script&lang=js"
export * from "./userDetail.vue?vue&type=script&lang=js"
import style0 from "./userDetail.vue?vue&type=style&index=0&id=0d92df07&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports